module.exports = __webpack_public_path__ + "img/video_top.4cacd1fb.jpg";